<template>
  <router-view></router-view>
</template>

<script>
  export default {
    name: 'TemplatesIndex',
    data: function () {
      return {
      }
    }
  }
</script>

<style lang="scss" scoped>
</style>
